import clsx from "clsx";
import moment from 'moment';
import React, { useState } from 'react';
import { DefaultButton } from '../editor/button';
import PhuHuynhCSKHDetailModal from './detail-modal/PhuHuynhCSKHDetailModal';
import styles from "./PhuHuynhCSKHItem.module.css";
import { PHU_HUYNH_API_END_POINT } from "../../api/phuHuynhApi";
import { HttpMethod, useCommonContext } from "../../contexts/common";
const PhuHuynhCSKHItem = ({ ts_chamsockhachhang, onChanged }) => {
    const { canAccessTo } = useCommonContext();
    const [isShowEditModal, setShowEditModal] = useState(false);
    return (
        <div className={clsx(styles.container, ts_chamsockhachhang.da_xu_ly ? styles.done : styles.pending)}>


            <div className={styles.khach_hang_info}>
                <div className={styles.info_container}>
                    <div className={clsx(styles.trang_thai, ts_chamsockhachhang.da_xu_ly ? styles.da_xu_ly : "")}>
                        <span>
                            {ts_chamsockhachhang.da_xu_ly ? "Đã xử lý" : "Chưa xử lý"}
                        </span>
                    </div>
                </div>
                <div className={styles.info_container}>
                    <i className="fas fa-user"></i>
                    <span>{ts_chamsockhachhang.ten_khach_hang}</span>
                </div>
                <div className={styles.info_container}>
                    <i className="fas fa-phone"></i>
                    <span>{ts_chamsockhachhang.dien_thoai}</span>
                </div>
                {/* <div className={styles.info_container}>
                    <i className="fas fa-clock"></i>
                    <span>Ngày tạo: {ts_chamsockhachhang.ngay_tao}</span>
                </div> */}
                {ts_chamsockhachhang.ma_hs &&
                    <div className={styles.info_container}>
                        <i className="fas fa-child"></i>
                        <span>{ts_chamsockhachhang.ma_hs} - {ts_chamsockhachhang.ho_ten_hoc_sinh}</span>
                    </div>
                }
            </div>
            <div className={styles.body}>
                {ts_chamsockhachhang.is_request ? <b>Yêu cầu từ Phụ huynh</b> : <b>Ghi chú từ Tuyển sinh</b>}
                {ts_chamsockhachhang.ngay_hen_tra_loi ? <b>( Hẹn trả lời PH ngày: {moment(ts_chamsockhachhang.ngay_hen_tra_loi).format("DD/MM/yyyy")})</b> : ""}
                {ts_chamsockhachhang.ngay_xu_ly ? <b>( Đã xử lý ngày: {moment(ts_chamsockhachhang.ngay_xu_ly).format("DD/MM/YYYY")})</b> : ""}
            </div>
            <div className={styles.header}>
                <div className={styles.noi_dung}>
                    <b>Nội dung:</b> {ts_chamsockhachhang.noi_dung}
                </div>
                <div className={styles.actions}>
                    {canAccessTo(PHU_HUYNH_API_END_POINT, HttpMethod.POST) &&
                        <DefaultButton text={""} icon="fas fa-edit" onClick={() => { setShowEditModal(true) }} />
                    }
                    {/* <DangerButton text={""} icon="fas fa-trash" /> */}
                </div>
            </div>

            <div className={styles.body}>
                <b>Người tạo: </b>{ts_chamsockhachhang.nguoi_tao} ({ts_chamsockhachhang.ngay_tao})
            </div>
            {/* <div className={styles.body}>
                <b>Ghi chú: </b>{ts_chamsockhachhang.ghi_chu}
            </div> */}
            {ts_chamsockhachhang.ket_qua_xu_ly &&
                <div className={styles.body}>
                    <b>Kết quả xử lý: </b>{ts_chamsockhachhang.ket_qua_xu_ly}
                </div>
            }
            {isShowEditModal &&
                <PhuHuynhCSKHDetailModal id={ts_chamsockhachhang.id}
                    onCancel={() => { setShowEditModal(false) }}
                    onSuccess={() => { setShowEditModal(false); onChanged(); }}
                />
            }
        </div>
    );
};

export default PhuHuynhCSKHItem;